export const patientTableAction = {
  changePage: (state, action) => {
    state.page = action.payload;
  },

  changePageSize: (state, action) => {
    state.pageSize = action.payload;
  },

  changeSearch: (state, action) => {
    state.searchText = action.payload;
  },

  changeFilters: (state, action) => {
    state.filters = action.payload;
  },

  changeOrder: (state, action) => {
    const { field, direction } = action.payload;

    state.orderBy = { field, direction };
  },

  togglePatientEnrollModal: (state, action) => {
    state.isPatientEnrollModal = action.payload;
  },

  refreshDeviceAlertList: (state, action) => {
    state.refreshDeviceAlertList = action.payload;
  },

  toggleFetchTableData: (state, action) => {
    state.fetchTableData = action.payload;
  },

  setPagination: (state, action) => {
    state.pagination = action.payload;
  },

  setSearch: (state, action) => {
    state.search = action.payload;
  },

  togglePatientAlert: (state, action) => {
    state.showPatientAlert = action.payload;
  },

  toggleDeviceAlert: (state, action) => {
    state.showDeviceAlert = action.payload;
  },

  toggleMissingContactInfo: (state, action) => {
    state.showMissingContactInfo = action.payload;
  },

  toggleAlertWhenDisconnected: (state, action) => {
    state.showAlertWhenDisconnected = action.payload;
  },

  changeSelectedRows: (state, action) => {
    const { patients = [], selectedRows = 0 } = action.payload;

    state.selectedPatients = patients;
    state.totalSelectedRows = selectedRows;
  },
};
